var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.823,
    height: 46.562,
    viewBox: "0 0 34.823 46.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(-99.773 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1_15_",
    transform: "translate(99.773 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36517",
    "data-name": "Path 36517",
    d: "M105.835,0H121.4L134.6,13.752V40.5a6.055,6.055,0,0,1-6.05,6.062H105.835A6.058,6.058,0,0,1,99.773,40.5V6.062A6.058,6.058,0,0,1,105.835,0Z",
    transform: "translate(-99.773 0)",
    fill: "#e5252a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25221",
    "data-name": "Group 25221",
    transform: "translate(6.736 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36518",
    "data-name": "Path 36518",
    d: "M467.219,0V13.648h13.205Z",
    transform: "translate(-452.338)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36519",
    "data-name": "Path 36519",
    d: "M214.278,454.464v-8.505H217.9a3,3,0,0,1,2.141.745,2.838,2.838,0,0,1,0,3.956,3,3,0,0,1-2.141.745h-1.443v3.06Zm2.176-4.91h1.2a1.072,1.072,0,0,0,.756-.233.9.9,0,0,0,0-1.28,1.072,1.072,0,0,0-.756-.233h-1.2Zm5.282,4.91v-8.505h3.013a5.26,5.26,0,0,1,1.675.256,4.5,4.5,0,0,1,1.419.756,3.34,3.34,0,0,1,1,1.326,5.258,5.258,0,0,1,0,3.828,3.34,3.34,0,0,1-1,1.326,4.5,4.5,0,0,1-1.419.756,5.264,5.264,0,0,1-1.675.256Zm2.129-1.85h.628a3.485,3.485,0,0,0,.942-.116,2.825,2.825,0,0,0,.8-.384,1.724,1.724,0,0,0,.582-.745,3.3,3.3,0,0,0,0-2.315,1.725,1.725,0,0,0-.582-.745,2.824,2.824,0,0,0-.8-.384,3.49,3.49,0,0,0-.942-.116h-.628Zm6.434,1.85v-8.505h6.05v1.85h-3.874v1.361h3.095v1.838h-3.095v3.456Z",
    transform: "translate(-214.278 -419.723)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.8809df5787dda4a0c86b484c10b12e96.svg";
export { ForwardRef as ReactComponent };